// extracted by mini-css-extract-plugin
module.exports = {"alert":"antdErrorAlert__alert___2CziW","alert-no-fixed":"antdErrorAlert__alert-no-fixed___1GsuS"};